export const homeTitle = '影爸爸 · 让好创意，拍成好作品';
export const pageTitles: Record<string, string> = {
  '/wechat/confirm': '微信登录确认',
  '/digital-resources': '数字资源素材库',
  '/projects': '项目协作',
  '/providers': '发现合拍的创作团队',
  '/demands': '需求大厅',
  '/resources': '影视资源',
  '/cases': '精选案例',
  '/ai': 'AI 创作',
  '/promotion': '视频推广',
  '/publish': '发布拍片需求',
  '/login': '登录与注册',
  '/about': '关于影爸爸',
  '/help': '帮助中心',
  '/privacy': '隐私政策',
  '/terms': '服务条款',
};
export const titleForPath = (path: string) =>
  pageTitles[path]
    ? `${pageTitles[path]} · 影爸爸`
    : path === '/' || /^\/(providers|demands|resources|cases|digital-resources)\/[^/]+$/.test(path)
      ? homeTitle
      : '页面未找到 · 影爸爸';

export const pageDescriptions: Record<string, string> = {
  '/digital-resources':
    '浏览视频、图片、音乐、后期模板和三维素材，按关键词、标签、软件查找，了解规格与商用授权范围。',
  '/projects':
    '用影爸爸管理创作项目的需求、知识产权、任务、会议和文件版本，导出 Word 或 PDF 需求书，与客户和团队协作。',
  '/about':
    '了解影爸爸如何连接企业客户、影视制作团队与行业资源，以及从需求到交付的合作流程。运营主体：广州和晟网络科技有限公司。',
  '/help':
    '查找影爸爸账号与入驻、项目协作、数字资源授权、影视资源、AI 创作与视频推广的使用说明和常见问题。',
  '/ai':
    '使用影爸爸整理创作需求、视频脚本、文字分镜与营销文案，编辑、保存和导出创作版本，了解当前能力与操作流程。',
  '/promotion':
    '用影爸爸管理视频推广任务、渠道文案、计划时间和作品链接，了解从内容准备到记录发布的完整流程。',
};

export const descriptionForPath = (path: string) =>
  pageDescriptions[path] ||
  '连接专业影视团队、行业资源与企业客户。从创作需求、项目协作到数字素材，让创作合作更简单。';
